export async function solveChallenge(
  challenge: string,
  difficulty: number,
): Promise<number> {
  let nonce = 0;
  const target = "0".repeat(difficulty);

  while (true) {
    const data = new TextEncoder().encode(challenge + nonce);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    const hex = Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");

    if (hex.startsWith(target)) return nonce;
    nonce++;
  }
}
